import { ITemplatesStore } from '../index'

export default function(store: ITemplatesStore): ITemplatesStore {
  return {
    ...store,
    request: {
      errMessage: '',
      isLoading: true,
    },
  }
}
